<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3><a href="#" data-bs-toggle="modal" data-bs-target="#myModalAddSpecialite"><i class="fa fa-plus-square"></i></a>&nbsp;Spécialités <span class="badge bgbadge">{{specialites.length}}</span> </h3>
                            <div class="table-responsive mb-5">
                                <template v-if="specialites.length>0">  
                                    <table class="table table-striped table-bordered display text-center mb-5">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Specialités</th>
                                                <th>Enrégistré le</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                                <tr v-for="speci in specialites" :key="speci.id">
                                                    <td>{{speci.id}}</td>
                                                    <td>{{speci.specialite}}</td>
                                                    <td>{{formatDate(speci.created)}}</td>
                                                    <td>
                                                        {{ speci.status === 1 ? 'Activé' : 'Désactivé' }}
                                                        
                                                    </td>
                                                    <td>
                                                        <button
                                                            data-bs-toggle="modal"
                                                            @click="getInfospecialite(speci)"
                                                            data-bs-target="#myModalAccepterAction"
                                                            class="btn btn-sm"
                                                            :class="speci.status === 1 ? 'btn-secondary':'btn-success'"
                                                        >
                                                            {{ speci.status === 1 ? 'Désactivé' : 'Activé' }}
                                                        </button>
                                                        <a href="#" class="text-inverse mx-3" @click="editSpecialite(speci)" title="Edit" data-bs-toggle="modal" data-bs-target="#myModalUpdateSpecialite"><i class="fa fa-edit"></i></a>
                                                    </td>                                                
                                                </tr>                                
                                        </tbody>
                                    </table>
                                </template>
                                <template v-else>
                                    <div class="modal-preloader">
                                        <div class="spinner"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
     <!--Begin All Modal -->
          <!--Begin Add Specialite -->
          <div class="modal" id="myModalAddSpecialite">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Enrégister Spécialité</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                        <div class="row" v-if="validationErrors.length>0">
                            <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                    <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                </ul>
                            </div>
                        </div>
                        <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                        <div class=" mx-auto">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="usname">Spécialité</label>
                                            <input type="text" v-model="form.nom" title="Ajouter Nom" placeholder="Nom" required id="usname" class="form-control" autofocus="true">
                                        </div>
                                    </div>                                    
                                </div>                                 
                                <div class="row text-center">
                                    <div class="pt-2">
                                        <button type="submit" class="btn btn-block btn-lg col-6" style="background:#00C853; color: #fff;" @click="registerSpecialite">Ajouter</button>
                                    </div>
                                </div>	
                        </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" id="closeModalAddSpecialite" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
         </div>
          <!--End Add Specialite -->

    <!-- The Modal Update Specialite-->
        <div class="modal" id="myModalUpdateSpecialite">
            <div class="modal-dialog">
                <div class="modal-content">             
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Modifier Spécialité</h5>
                        <button type="button" id="closeModifierUser" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                    <!-- Modal body -->
                    <div class="modal-body">
                        <p v-if="success_msg" class="text-white alert text-center" style="background: #00C853;">{{ success_msg }}</p>
                        <template v-if="form_update?.id">
                            <div class="col-lg-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form @submit.prevent="UpdateSpecialite">
                                            <div class="row" v-if="validationErrors.length>0">
                                                <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                                    <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                                        <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-4">
                                                    <p class="mb-0">Specialité</p>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" v-model="form_update.specialite" class="form-control">
                                                </div>
                                            </div>
                                        </form>   
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <!-- <p class="text-center">Loading...</p> -->
                            <div class="modal-preloader">
                                <div class="spinner"></div>
                            </div>
                        </template>
                    </div>
                    
                    <!-- Modal footer -->
                    <div class="modal-footer d-flex justify-content-between">
                        <button type="button" id="closeModalUpdated" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        <button type="button" :disabled="form_update.specialite =='' || form_update.id==''" class="btn float-left" style="background-color: #00C853; color: #fff;" @click="UpdateSpecialite">Enrégistrer</button>
                    </div>
                    
                </div>
            </div>
        </div>
    <!-- End Modal Update Specialite -->

    <!-- Start Modal accepter ou desactiver -->
        <div class="modal" id="myModalAccepterAction">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content  border-0 shadow-lg rounded-4">

                <!-- Modal Header -->
                <div class="modal-header">
                    <p>⚠️Confirmation d'action</p>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div class="row text-center">
                        <p><i class="bi bi-question-circle text-danger fs-1 mb-3"></i></p>
                        <div class="modal-body">
                            <p v-if="specis.status == 1" class="fw-bold fs-5 text-danger">
                                 Voulez-vous vraiment <strong>désactiver</strong> la spécialité <span class="text-decoration-underline">{{ specis.specialite }}</span> ?
                            </p>
                            <p v-else class="fw-bold fs-5 text-success">
                                ✅ Voulez-vous vraiment <strong>activer</strong> la spécialité <span class="text-decoration-underline">{{ specis.specialite }}</span> ?
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"><i class="bi bi-x-circle me-1"></i> NON</button>
                    <button type="button" class="btn btn-success ms-auto" @click="confirmerAction"><i class="bi bi-check-circle me-1"></i>OUI</button>
                </div>

                </div>
            </div>
        </div>
    <!-- End Modal accepter desactiver -->

        <!-- End All Modal -->
</template>
<script>
import DashView from "@/components/DashView.vue"
import axios from 'axios'
  import $ from 'jquery';
  const base_url=process.env.VUE_APP_API_URL;
export default {
    name:"SpecialiteAll",
    components:{
        DashView
    },
    data(){
      return{
          specialites:[],
          specis:[],
          success_msg:'',
        //   editeurAssurance:[],
          validationErrors:[],
          accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
          form:{
            nom:''
          },
          form_update:{
            id:'',
            specialite:''
          }
      }
    },
    created(){
        // (JSON.parse(localStorage.getItem('user_zgc')).code_role)>3 ? this.$router.push('all-vente'):true;
        // const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
        axios.get(`${base_url}/all-specialite`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                console.log('Specialités!!');
                
                //   console.log(response.data);
                  if(response.data){
                      this.specialites = response.data;
                  }
                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
    },
    methods:{
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year}`;
        },
        getInfospecialite(code){ 
                //   console.log(code);
                const accessToken = JSON.parse(localStorage.getItem('user_zgc')).token ?? '';
                axios.get(`${base_url}/infoassurance?code=${code}`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${accessToken}`
                }
            })
            .then((response)=>{
                const info = response.data;
            //   console.log(info);
                this.updateModalContent(info);
            })
            .catch((error)=>{
            if(error?.response?.status === 403){
                    console.log('NO access');
                    $('#openModalNoAccess').trigger('click');
            }
            else {
            // Gérer d'autres erreurs ici
            console.log('Une erreur est survenue!');
            console.log('Autre erreur:', error);
            }
            })
        },
        updateModalContent(donnee){
            this.info_assurance=donnee;
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
            location.reload();
            }, 1);
        },
        registerSpecialite(){
            console.log('ok');
            // console.log(this.form);
            this.success_msg='';
            // return false;
            const control = !!(this.form.nom);
            console.log(control);
            if(control){
                    const $data ={
                    specialite : this.form.nom
                };
                // console.log($data);
                axios.post(`${base_url}/insert-specialite`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    // console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Specialité ajoutée avec success!`;
                        setTimeout(function() {
                            location.reload();
                        },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#closeModalAddSpecialite').trigger('click');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }
        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        editSpecialite(specialite){
            this.form_update = {
                id: '',
                specialite: ''
            };
            if(specialite){
                this.form_update.id = specialite.id;
                this.form_update.specialite = specialite.specialite;
            }
        },
        UpdateSpecialite(){
            const $data={
                id:this.form_update.id,
                specialite:this.form_update.specialite
            };
            // console.log($data);
            // return false;
            
            if($data){
                axios.put(`${base_url}/update_specialite`,$data,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response?.data);
                    if(response?.status==200){
                        setTimeout(function() {
                            location.reload();
                        },1);
                    }                
                })
                .catch((error)=>{
                    // console.log(error);
                        if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            this.displayValidationErrors(error.response.data.errors);                       
                        } 
                        else if(error?.response?.status === 403){
                            // this.$router.push('/no-access');
                            console.log('NO access');
                            $('#closeModalUpdateSpecialite').trigger('click');
                            $('#openModalButton').trigger('click');
                        }
                        else {
                        // Gérer d'autres erreurs ici
                        console.log('Autre erreur:', error);
                        }
                });
            }
        },
        toggleStatus(specialite) {
            // console.log('toggleStatus');
            // console.log(specialite);
            
            
            const newStatus = specialite.status === 1 ? 0 : 1;
            axios.put(`${base_url}/update_status_specialite`, {
            id: specialite.id,
            status: newStatus
            }, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${this.accessToken}`
                }
            })
            .then(response => {
                specialite.status = newStatus; // Mise à jour visuelle immédiate
                setTimeout(function() {
                location.reload();
                }, 1);
            })
            .catch(error => {
            console.error('Erreur lors de la mise à jour du statut :', error);
            });
        },
        getInfospecialite(data){
            this.specis = data;
            // console.log(data);
            
        },
        confirmerAction(){
            this.toggleStatus(this.specis);
            
        }
    }
}
</script>
<style lang="">
    
</style>